import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Settings = lazy(() => import("@/pages/Settings"));
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
export const Route = createFileRoute("/settings")({
  component: () => (
    <ProtectedRoute>
      <Settings />
    </ProtectedRoute>
  ),
});
